module.exports = __webpack_public_path__ + "static/media/CardioWarrior.395ff632.svg";